import { type UseFormReturn, useForm, useNavigate } from '@fukuri-admins/hooks/common';
import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { login } from '../../../api/sign_in';
import { UserInfo, useAuth } from '../../../components/auth/AuthProvider';
import { getClientsLink } from '../../../utils/getLinks';
import { LoginFormFieldValues, loginSchema } from '../logics/schema';

type IUseLoginModal = () => {
  state: {
    methods: UseFormReturn<LoginFormFieldValues>;
    errMsg: string;
    buttonDisabled: boolean;
  };
  actions: {
    handleSubmit: () => Promise<void>;
  };
};

export const useLoginModal: IUseLoginModal = () => {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const [errMsg, setErrMsg] = useState<string>('');

  const methods = useForm<LoginFormFieldValues>({
    defaultValues: {
      email: '',
      password: '',
      partnerCode: '',
    },
    criteriaMode: 'all',
    mode: 'onChange',
    resolver: zodResolver(loginSchema),
  });

  const handleSubmit = methods.handleSubmit(async ({ email, password, partnerCode }) => {
    try {
      const response = await login({
        partner_admin_user: {
          email,
          password,
          code: partnerCode,
        },
      });
      const data = await response.json();
      const userInfo = data as UserInfo;
      signIn(userInfo, partnerCode);
      navigate(getClientsLink());
    } catch {
      setErrMsg('ログインできませんでした。ネットワークの状態を確認し、もう一度お試しください。');
    }
  });

  // フォームの状態からボタンの無効状態を計算
  const { isValid, isSubmitting } = methods.formState;
  const buttonDisabled = !isValid || isSubmitting;

  return {
    state: {
      methods,
      errMsg,
      buttonDisabled,
    },
    actions: {
      setErrMsg,
      handleSubmit,
    },
  };
};
